(() => {
  if (window.blincSizeGuideReady) return;
  window.blincSizeGuideReady = true;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-blinc-size-open]');
    if (opener) {
      const id = opener.dataset.blincSizeOpen;
      const dialogs = [...document.querySelectorAll('dialog[data-blinc-size-product]')];
      const dialog = dialogs.find(item => item.dataset.blincSizeProduct === id);
      if (!dialog || dialog.open) return;
      dialog.blincOpener = opener;
      dialog.showModal();
      dialog.scrollTop = 0;
      dialog.addEventListener('close', () => { if (dialog.blincOpener?.isConnected) dialog.blincOpener.focus(); }, { once: true });
      return;
    }
    const closer = event.target.closest('[data-blinc-size-close]');
    if (closer) closer.closest('dialog').close();
    const dialog = event.target.closest('dialog[data-blinc-size-product]');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
})();
